import { ui } from '@owenscorning/pcb.alpha';
import _ from 'lodash';
import { parse } from 'date-fns';

import CheckboxSelector from '../../../ComponentLibrary/filter-list/oc-filters';
import SwoogoEvents from './helpers/SwoogoEvents';

const buildDateRanges = events => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const ranges = {
    7: 7,
    30: 30,
    90: 90,
  };

  return Object.entries(ranges)
    .map(([key, days]) => {
      const hasEvent = events.some(event => {
        if (!event.start_date) return false;
        const eventDate = parse(event.start_date, 'MMMM d, yyyy', new Date());
        eventDate.setHours(0, 0, 0, 0);

        const maxDate = new Date(today);
        maxDate.setDate(today.getDate() + days);

        return eventDate >= today && eventDate <= maxDate;
      });

      return hasEvent
        ? {
            value: `next_${key}`,
            displayName: `Next ${days} Days`,
          }
        : null;
    })
    .filter(Boolean);
};

const generateFilters = (events, enabledFilters) => {
  if (!events || events.length === 0) return null;

  const stateOptions = _.uniqBy(
    events.map(event => ({
      value: event.location.state,
      displayName: event.location.state,
    })),
    'value'
  );

  const filters = {};

  if (enabledFilters.includes('state') && stateOptions.length > 0) {
    filters.state = {
      component: CheckboxSelector,
      displayLimit: 5,
      displayName: 'State',
      options: stateOptions,
      valueType: 'multiple',
    };
  }

  const dateRanges = buildDateRanges(events);
  if (enabledFilters.includes('start_date') && dateRanges.length > 0) {
    filters.date_range = {
      component: CheckboxSelector,
      displayLimit: 5,
      displayName: 'Date Range',
      options: dateRanges,
      valueType: 'multiple',
    };
  }

  return Object.keys(filters).length > 0 ? filters : null;
};

const eventsResponse = (events, meta = {}) => {
  const parsedEvents = [];

  events.forEach(event => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const eventDate = parse(event.start_date, 'MMMM d, yyyy', new Date());
    eventDate.setHours(0, 0, 0, 0);

    let dateRange = null;
    let milisecondsInDay = 24 * 60 * 60 * 1000
    if (eventDate >= today && eventDate <= new Date(today.getTime() + 7 * milisecondsInDay)) {
      dateRange = 'next_7';
    } else if (eventDate >= today && eventDate <= new Date(today.getTime() + 30 * milisecondsInDay)) {
      dateRange = 'next_30';
    } else if (eventDate >= today && eventDate <= new Date(today.getTime() + 90 * milisecondsInDay)) {
      dateRange = 'next_90';
    }

    parsedEvents.push({
      id: event.id,
      name: event.name,
      description: event.description,
      url: event.url,
      start_date: event.start_date,
      start_end_date: event.start_end_date,
      end_date: event.end_date,
      start_time: event.start_time,
      end_time: event.end_time,
      timezone: event.timezone,
      venue_type: event.event_venue_type,
      capacity: event.capacity,
      status: event.status,
      location: event.location,
      city: event.location.city,
      state: event.location.state,
      folder_id: event.folder_id,
      swoogo_id: event.swoogo_id,
      date_range: dateRange,
    });
  });

  const filters = generateFilters(events, ['state', 'start_date']);

  return {
    lists: [{ name: 'results', data: parsedEvents }],
    filters,
    Component: SwoogoEvents,
    meta,
  };
};

export default {
  ItemList: {
    availableIn: ['www.owenscorning.com'],
    name: 'Swoogo Events',

    view: (data = null) => {
      const {
        data: items,
        meta: { parameters, filters },
      } = data || { meta: {} };

      return eventsResponse(items || []);
    },
  },
};
